<div class="container" fxlayout="column" fxLayoutAlign="center start">
  <div class="form-container" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="24px">

    <!-- Navigation Tabs -->
    <div *ngIf="isDeviceConnectMode" fxLayout="row" class="dialog-nav">
      <nav mat-tab-nav-bar>
        <a mat-tab-link [active]="mode === saveMode" [disabled]="false" (click)="changeMode(saveMode)">
          {{ 'dataUploadDialog.fromPC' | translate }}
        </a>
        <a mat-tab-link [active]="mode === iplexGMode" [disabled]="false" (click)="changeMode(iplexGMode)">
          {{ 'dataUploadDialog.fromIPLEX' | translate }}
        </a>
      </nav>
    </div>

    <!-- Save Mode Content -->
    <ng-container *ngIf="mode === saveMode">
      <div class="chrome-div" fxlayout="column">
        <div class="upload">
          <h3 class="headline">
            <ng-container *ngIf="!isOffline">
              <span>{{ 'dataUploadDialog.uploadNotFromOSCData' | translate }}</span>
            </ng-container>
            <ng-container *ngIf="isOffline">
              <span>{{ 'dataUploadDialog.importInspectionImagesIntoStorage' | translate }}</span>
            </ng-container>
          </h3>

          <!-- File Uploaders -->
          <input id="folder-uploader" hidden #folderSelector type="file" webkitdirectory directory (change)="processSelectedFiles($event.target.files)" />
          <input id="file-uploader" hidden #fileSelector type="file" multiple [accept]="acceptedImages" (change)="processSelectedFiles($event.target.files)" />
        </div>

        <!-- Non-OSC Data Display Container -->
        <div class="display-container" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDropFolder($event)" [class.drag-over]="isDragOver">

          <ng-container *ngFor="let uploadFile of imageFileNameList">{{uploadFile}}<br></ng-container>
          <div *ngIf="imageFileNameList.length === 0 && (!selectFolderFlag || isMobileDevice)">
            <div class="import-options">
              <!-- Import Folder -->
              <!-- //TODO replace with openDirectoryPicker() -->
              <div class="import-option" (click)="useApplicationFileManager ? showFileManager({ selectionMode: SelectionMode.SingleFolder }) : folderSelector.click()">
                <img src="assets/icons/uploadImages/folder.svg">
                <div class="import-content">
                  <evc-svg-icon icon="download" size="sm" class="import-media"></evc-svg-icon>
                  <div class="import-text">{{ 'dataUploadDialog.importFolder' | translate }}</div>
                </div>
              </div>

              <!-- Divider -->
              <div class="divider"></div>

              <!-- Import Files -->
              <!-- //TODO replace with openFilePicker() -->
              <div class="import-option" (click)="useApplicationFileManager ? showFileManager({ selectionMode: SelectionMode.MultipleFiles }) : fileSelector.click()">
                <img src="assets/icons/uploadImages/files.svg">
                <div class="import-content">
                  <evc-svg-icon icon="download" size="sm" class="import-media"></evc-svg-icon>
                  <div class="import-text">{{ 'dataUploadDialog.importFiles' | translate }}</div>
                </div>
              </div>
            </div>

            <!-- Drag & Drop Text -->
            <p class="drag-drop-text">{{ 'dataUploadDialog.dragDrop' | translate }}</p>
          </div>
        </div>

        <!-- Submit Buttons -->
        <div fxLayout="end center" class="submit">
          <button mat-button id="close-button" color="primary" [mat-dialog-close]="true">
            {{ 'dataUploadDialog.close' | translate }}
          </button>
          <button *ngIf="!isOffline" [disabled]="!isReadCompleted || imageFileNameList.length === 0" mat-raised-button color="primary" (click)="uploadFile()">
            {{ 'dataUploadDialog.startUpload' | translate }}
          </button>
          <button *ngIf="isOffline" [disabled]="!isReadCompleted || imageFileNameList.length === 0" mat-raised-button color="primary" (click)="uploadFile()">
            {{ 'dataUploadDialog.importAsSave' | translate }}
          </button>
        </div>
      </div>
    </ng-container>

    <!-- iPLEX G Mode Component -->
    <ng-container *ngIf="mode === iplexGMode">
      <app-save-iplex-g-images (importIplexGImages)="transferImageFromDevice($event)" (closeEmitter)="dialogClose()"></app-save-iplex-g-images>
    </ng-container>
  </div>
</div>
